module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "center-block row"
  }, [(_vm.getRoleType === 99) ? _c('div', {
    staticClass: "align-center col-xs-12 flex m-b-10 p-x-0"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.goBackInfo
    }
  }, [_c('div', {
    staticClass: "btn btn-default flex m-r-5"
  }, [_c('span', [_vm._v("返回")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.title)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.goBackInfo.subtitle)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "darken-1 flex grey"
  }, [(_vm.brand.name || _vm.store.brand_name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s(_vm.brand.name ?
        _vm.brand.name :
        _vm.store.brand_name ?
        _vm.store.brand_name :
        '')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    staticClass: "m-r-5",
    domProps: {
      "textContent": _vm._s('/')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.store.name) ? _c('div', {
    domProps: {
      "textContent": _vm._s(_vm.store.name)
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("ID")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.menu_id) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("名稱")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.name) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.description) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.remark) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                版本號\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.ver_stamp) + "\n              ")])]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "box-body form-right"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                鎖定狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [(_vm.info.is_locked) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("\n                  鎖定\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.info.is_locked) ? _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("\n                  可更新\n                ")]) : _vm._e(), _vm._v(" "), (_vm.info.is_locked && _vm.info.status === 2) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.menuUnlock
    }
  }, [_vm._v("\n                  解除鎖定\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.info.is_locked && _vm.info.status === 2) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.menuLock
    }
  }, [_vm._v("\n                  鎖定\n                ")]) : _vm._e(), _vm._v(" "), (_vm.info.is_locked && _vm.info.status === 2) ? _c('button', {
    staticClass: "bg-black btn",
    on: {
      "click": function($event) {
        return _vm.goToCrSchedule(_vm.info)
      }
    }
  }, [_vm._v("\n                  上架\n                ")]) : _vm._e(), _vm._v(" "), (_vm.info.is_locked && _vm.info.status === 2) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.exportFile
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("\n                  匯出菜單\n                  "), _c('clip-loader', {
    staticClass: "cliploading",
    attrs: {
      "loading": _vm.show.download,
      "color": "#528BB8",
      "size": "16px"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                菜單狀態\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.status) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                版本時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.ver_time) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                更新時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.update_time) + "\n              ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n                建立時間\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n                " + _vm._s(_vm.info.create_time) + "\n              ")])]), _vm._v(" "), _c('br')])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [(_vm.show.noMenu) ? _c('div', {
    staticClass: "text-center text-red"
  }, [_vm._v("\n            尚未建立菜單喔！\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dataTables_wrapper dt-bootstrap form-inline",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "grid row"
  }, [_c('MenuLogic', {
    attrs: {
      "type": "list",
      "menu": _vm.menu,
      "schema": _vm.schema,
      "layout": _vm.layout,
      "show-product-icon": _vm.showProductIcon,
      "change-to-product-list": _vm.changeToProductList,
      "check-disable-item": _vm.checkDisableItem,
      "open-modal": _vm.openModal,
      "get-icon": _vm.getIcon,
      "is-search": _vm.isSearch,
      "show-menu-icon": _vm.showMenuIcon,
      "loading": _vm.loading,
      "min-price": _vm.minPrice
    }
  })], 1)])])])]), _vm._v(" "), _c('MenuModal', {
    attrs: {
      "current-product": _vm.currentProduct,
      "menu-json": _vm.currentMenuJson
    }
  }), _vm._v(" "), _c('PackageModal', {
    attrs: {
      "current-product": _vm.currentProduct,
      "menu-json": _vm.currentMenuJson
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("\n            菜單資訊\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("\n            菜單\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73be14a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/MenuInfo.vue
// module id = 2479
// module chunks = 1